class ScrollShrink extends HTMLElement {
  connectedCallback() {
    this.container = this.querySelector('.scroll-shrink-container');
    if (!this.container) return;

    this.handleScroll = () => {
      requestAnimationFrame(() => {
        const rect = this.getBoundingClientRect();
        const windowHeight = window.innerHeight;
        
        // Calculate the center of the element relative to the viewport
        const elementCenter = rect.top + (rect.height / 2);
        const viewportCenter = windowHeight / 2;
        
        // Calculate distance from center (absolute value)
        const distanceFromCenter = Math.abs(elementCenter - viewportCenter);
        
        // When distance is 0, progress is 0 (fully expanded).
        // When distance is >= maxDistance, progress is 1 (fully shrunk).
        const maxDistance = windowHeight / 1.5; 
        
        let progress = Math.min(distanceFromCenter / maxDistance, 1);
        
        this.style.setProperty('--scroll-shrink-progress', progress);
      });
    };

    window.addEventListener('scroll', this.handleScroll, { passive: true });
    // Initialize on load
    this.handleScroll();
  }

  disconnectedCallback() {
    window.removeEventListener('scroll', this.handleScroll);
  }
}

if (!customElements.get('scroll-shrink')) {
  customElements.define('scroll-shrink', ScrollShrink);
}
